import { render, staticRenderFns } from "./ProductsContent.vue?vue&type=template&id=5fd53fd6&scoped=true&"
import script from "./ProductsContent.vue?vue&type=script&lang=js&"
export * from "./ProductsContent.vue?vue&type=script&lang=js&"
import style0 from "./ProductsContent.vue?vue&type=style&index=0&id=5fd53fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd53fd6",
  null
  
)

export default component.exports